export const buySaleGuideTypes = {
    BUY_SALE_GUIDE_ACTION_START: "BUY_SALE_GUIDE_ACTION_START",
    BUY_SALE_GUIDE_GET_SUCCESS: "BUY_SALE_GUIDE_GET_SUCCESS",
    BUY_SALE_GUIDE_GET_FAILED: "BUY_SALE_GUIDE_GET_FAILED",
    BUY_SALE_GUIDE_ACTION_END: "BUY_SALE_GUIDE_ACTION_END",
}
